/**
 * Schulungs-Modus-Hinweis ist jetzt filigran in den AppHeader integriert:
 *   - dezenter violetter Ring um das Logo
 *   - kleines „SCHULUNG"-Chip neben dem Logo (nur ab sm-Breakpoint)
 *   - violett gefärbte Header-Border statt grobem Full-Width-Banner
 *
 * Diese Komponente bleibt aus Kompatibilitätsgründen als no-op exportiert,
 * damit Imports nicht crashen. Sie rendert bewusst nichts mehr.
 */
export const TrainingModeBanner = () => null;
